























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class AboutUsNewsArticle extends Vue {
  @Prop(String) title!: string;
  @Prop(String) displayedTitle!: string;
  @Prop(String) text!: string;
  @Prop(String) imgSrc!: string;
  @Prop(String) link!: string;

  get backgroundImageStyle() {
    return {
      backgroundImage: `url('${this.imgSrc}')`,
    };
  }
}
